/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SpecSpecKeyEnum = {
    Mileage: 'MILEAGE',
    Registration: 'REGISTRATION',
    Bedrooms: 'BEDROOMS',
    Bedroomlayout: 'BEDROOMLAYOUT',
    Seats: 'SEATS',
    Doors: 'DOORS',
    Range: 'RANGE',
    Fastestcharge: 'FASTESTCHARGE',
    Batterywarranty: 'BATTERYWARRANTY',
    Berth: 'BERTH',
    Dimensions: 'DIMENSIONS',
    Endlayout: 'ENDLAYOUT',
    Style: 'STYLE',
    Subcategory: 'SUBCATEGORY',
    Powerbhp: 'POWERBHP',
    Enginesizepower: 'ENGINESIZEPOWER',
    Gvw: 'GVW',
    Emissionclass: 'EMISSIONCLASS',
    Owners: 'OWNERS',
    Keys: 'KEYS',
    Axleconfig: 'AXLECONFIG',
    Traileraxlenumber: 'TRAILERAXLENUMBER',
    Gearbox: 'GEARBOX',
    Bodytype: 'BODYTYPE',
    Cabtype: 'CABTYPE',
    Enginesizelitres: 'ENGINESIZELITRES',
    Enginesizecc: 'ENGINESIZECC',
    Enginepower: 'ENGINEPOWER',
    Fueltype: 'FUELTYPE',
    Servicehistory: 'SERVICEHISTORY',
    Bikelicencetype: 'BIKELICENCETYPE',
    Category: 'CATEGORY',
    Hoursused: 'HOURSUSED',
    Liftingcapacity: 'LIFTINGCAPACITY',
    Operatingwidth: 'OPERATINGWIDTH',
    Maxreach: 'MAXREACH',
    Operatingtype: 'OPERATINGTYPE',
    Fullmanufacturerwarranty: 'FULLMANUFACTURERWARRANTY',
    Driverposition: 'DRIVERPOSITION',
    Wheelbase: 'WHEELBASE',
    Topspeed: 'TOPSPEED',
    Framesizecm: 'FRAMESIZECM',
    Batterycapacity: 'BATTERYCAPACITY',
    Suspensiontype: 'SUSPENSIONTYPE',
    Gearshifter: 'GEARSHIFTER',
    Gears: 'GEARS',
    Peaktorque: 'PEAKTORQUE',
    Colour: 'COLOUR',
    Framestyle: 'FRAMESTYLE',
    Framematerial: 'FRAMEMATERIAL',
    Motorpower: 'MOTORPOWER',
    Motortype: 'MOTORTYPE',
    Braketype: 'BRAKETYPE',
    Numberofgears: 'NUMBEROFGEARS',
    Motormanufacturer: 'MOTORMANUFACTURER',
    Tyrediameterinches: 'TYREDIAMETERINCHES',
    Chargetimeminutes: 'CHARGETIMEMINUTES',
    Claimedmaxrange: 'CLAIMEDMAXRANGE',
    Maxspeed: 'MAXSPEED'
};
/**
 * Check if a given object implements the Spec interface.
 */
export function instanceOfSpec(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    if (!('specKey' in value) || value['specKey'] === undefined)
        return false;
    return true;
}
export function SpecFromJSON(json) {
    return SpecFromJSONTyped(json, false);
}
export function SpecFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'value': json['value'],
        'info': json['info'] == null ? undefined : json['info'],
        'specKey': json['specKey'],
    };
}
export function SpecToJSON(json) {
    return SpecToJSONTyped(json, false);
}
export function SpecToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'value': value['value'],
        'info': value['info'],
        'specKey': value['specKey'],
    };
}
